<script>
import CallbackButton from "@js/components/Buttons/CallbackButton.vue";
import CatalogButton from "@js/components/Buttons/CatalogButton.vue";
import OnlyMobile from "@js/components/DynamicComponents/OnlyMobile.vue";
import HomeTopCardSlider from "@js/components/Sections/TopComponents/Components/Home/HomeTopCardSlider.vue";
import OnlyDesktop from "@js/components/DynamicComponents/OnlyDesktop.vue";
import ServicesTopForm from "@js/components/Sections/Callback/ServicesTopForm.vue";
import HomeTopForm from "@js/components/Sections/Callback/HomeTopForm.vue";
import {Swiper, SwiperSlide} from "swiper/vue";
import {Pagination, Autoplay} from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import IconArrowRight from "@js/components/Icons/IconArrowRight.vue";
import {Link} from "@inertiajs/vue3";

export default {
    name: "HomeTopComponent",
    components: {
        IconArrowRight,
        HomeTopForm,
        ServicesTopForm,
        OnlyDesktop,
        HomeTopCardSlider,
        OnlyMobile,
        CatalogButton,
        CallbackButton,
        Swiper,
        SwiperSlide,
        Link
    },
    data() {
        return {
            swiper: null,
        }
    },
    methods: {
        setSwiper(swiperInstance) {
            this.swiper = swiperInstance;
        },
        slideNext() {
            if (this.swiper && !this.swiper.isEnd) this.swiper.slideNext();
        },
        slidePrev() {
            if (this.swiper && !this.swiper.isBeginning) this.swiper.slidePrev();
        },
    },
    setup() {
        return {
            modules: [Pagination, Autoplay],
        };
    },
};
</script>

<template>
    <div class="container">
        <div class="grid grid-cols-12 pt-10 gap-5">
            <div class="group col-span-12 md:col-span-7 relative">
                <button v-if="swiper && !swiper.isBeginning" @click="slidePrev" aria-label="Назад"
                        class="max-md:hidden opacity-0 group-hover:opacity-100 absolute top-1/2 -translate-y-1/2 left-2 z-10 bg-black/50 hover:bg-black/70 border-2 border-white text-white rounded-full w-8 h-8 flex items-center justify-center transition backdrop-blur">
                    <IconArrowRight class="w-5 h-5 rotate-180"/>
                </button>
                <Swiper :slides-per-view="1"
                        :space-between="0"
                        @swiper="setSwiper"
                        :loop="false"
                        :modules="modules"
                        :pagination="{ clickable: true }"
                        :autoplay="{ delay: 5000, disableOnInteraction: true }"
                        class="rounded-2xl overflow-hidden shadow-lg pagination-indigo long_bullet">
                    <SwiperSlide>
                        <div
                            class="flex items-center p-5 md:p-16 relative w-full h-[300px] md:h-[500px] slide-bg-img-1 bg-no-repeat bg-cover bg-center">
                            <div class="text-white grow">
                                <h1 class="text-xl md:text-3xl font-bold mb-3">
                                    Дорожные Плиты 2П30.18.30 <br/>
                                    ТУ И ГОСТ
                                </h1>
                                <p class="md:text-xl font-semibold mb-3 underline-hover-effect underline-hover-effect-light underline-hover-pre-effect">
                                    Мы являемся прямым производителем
                                </p>
                                <ul class="max-w-xl space-y-1 list-disc list-outside text-sm md:text-base ms-5 mb-5 font-semibold">
                                    <li>
                                        Производство: От 300 изделий в день
                                    </li>
                                    <li class="max-md:hidden">
                                        Быстрая доставка
                                    </li>
                                    <li>
                                        Собственный автопарк
                                    </li>
                                    <li class="max-md:hidden">
                                        Полная документация
                                    </li>
                                </ul>
                                <div class="flex justify-center items-center md:justify-start">
                                    <Link :href="route('catalog', {
                                        base_categories: JSON.stringify(['dorozhno-transportnoe-stroitelstvo']),
                                        categories: JSON.stringify(['plity-dlya-dorozhnogo-stroitelstva']),
                                        sub_categories: JSON.stringify(['2p30'])
                                    })" type="button"
                                          class="max-md:w-full text-center text-white border-2 border-indigo-600 bg-indigo-600 hover:border-white hover:bg-transparent font-medium rounded text-md px-10 p-2 focus:outline-none transition">
                                        Узнать больше
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div
                            class="flex items-center p-5 md:p-16 relative w-full h-[300px] md:h-[500px] slide-bg-img-2 bg-no-repeat bg-cover bg-center">
                            <div class="text-white grow">
                                <p class="text-xl md:text-3xl font-bold mb-3">
                                    Работаем в режиме 24/7
                                </p>
                                <p class="font-semibold mb-3 md:mb-1">
                                    Примем заказ, проконсультируем и отгрузим в удобное для вас время.
                                </p>
                                <p class="font-semibold mb-5">
                                    Днем и ночью. Без праздников и выходных.
                                </p>
                                <div class="flex justify-center items-center md:justify-start">
                                    <Link :href="route('contacts')" type="button"
                                          class="max-md:w-full text-center text-white border-2 border-indigo-600 bg-indigo-600 hover:border-white hover:bg-transparent font-medium rounded text-md px-10 p-2 focus:outline-none transition">
                                        Наши контакты
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div
                            class="flex items-center p-5 md:p-16 relative w-full h-[300px] md:h-[500px] slide-bg-img-3 bg-no-repeat bg-cover bg-center">
                            <div class="text-white grow">
                                <p class="text-xl md:text-3xl font-bold mb-3">
                                    Продукция высокого качества
                                </p>
                                <ul class="max-w-xl space-y-1 list-disc list-outside text-sm md:text-base ms-5 mb-5 font-semibold">
                                    <li>
                                        Новые формы
                                    </li>
                                    <li>
                                        Используем цемент от Хайдельбергцемент
                                    </li>
                                    <li>
                                        Марка бетона М350 B25
                                    </li>
                                    <li>
                                        Армирование 7*11 (8мм)
                                    </li>
                                </ul>
                                <div class="flex justify-center items-center md:justify-start">
                                    <Link :href="route('catalog')" type="button"
                                          class="max-md:w-full text-center text-white border-2 border-indigo-600 bg-indigo-600 hover:border-white hover:bg-transparent font-medium rounded text-md px-10 p-2 focus:outline-none transition">
                                        Перейти в каталог
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                </Swiper>
                <button v-if="swiper && !swiper.isEnd" @click="slideNext" aria-label="Вперед"
                        class="max-md:hidden opacity-0 group-hover:opacity-100 absolute top-1/2 -translate-y-1/2 right-2 z-10 bg-black/50 hover:bg-black/70 border-2 border-white text-white rounded-full w-8 h-8 flex items-center justify-center transition backdrop-blur">
                    <IconArrowRight class="w-5 h-5"/>
                </button>
            </div>
            <div class="col-span-12 md:col-span-5">
                <div class="grid grid-cols-1 w-full h-[300px] md:h-[500px] gap-5">
                    <Link :href="route('catalog', {
                                base_categories: JSON.stringify(['dorozhno-transportnoe-stroitelstvo']),
                                categories: JSON.stringify(['aerodromnye-plity'])
                            })"
                          class="relative rounded-2xl overflow-hidden group shadow-lg">
                        <div
                            class="absolute inset-0 aerodromnaya-bg transition-transform duration-300 ease-in-out group-hover:scale-110"></div>
                        <div
                            class="absolute inset-0 bg-black opacity-0 transition-opacity duration-300 ease-in-out group-hover:opacity-50"></div>
                        <div class="bg-shadow absolute bottom-0 p-5 w-full text-white font-semibold text-xl">
                            Плита аэродромная ПАГ-14
                        </div>
                    </Link>
                    <Link :href="route('services')" class="relative rounded-2xl overflow-hidden group shadow-lg">
                        <div
                            class="absolute inset-0 ukladka-bg transition-transform duration-300 ease-in-out group-hover:scale-110"></div>
                        <div
                            class="absolute inset-0 bg-black opacity-0 transition-opacity duration-300 ease-in-out group-hover:opacity-50"></div>
                        <div class="bg-shadow absolute bottom-0 p-5 w-full text-white font-semibold text-xl">
                            Укладка плит под ключ
                        </div>
                    </Link>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
::v-deep(.swiper-pagination-bullet) {
    background: white !important; /* Делаем точки белыми */
    opacity: 0.6; /* Делаем их слегка прозрачными */
    transition: opacity 0.3s ease;
}

::v-deep(.swiper-pagination-bullet-active) {
    background: white !important; /* Активная точка тоже белая */
    opacity: 1; /* Делаем активную точку полностью непрозрачной */
}

.bg-shadow {
    background: linear-gradient(to top, rgba(0, 0, 0, .6) 20%, transparent);;
}

.slide-bg-img-1 {
    background: linear-gradient(rgba(0, 0, 0, .65), rgba(0, 0, 0, .65)), url('@img/home/slider/1.webp') no-repeat bottom;
    background-size: cover !important;
}

.slide-bg-img-2 {
    background: linear-gradient(rgba(0, 0, 0, .6), rgba(0, 0, 0, .6)), url('@img/home/slider/2.webp') no-repeat bottom;
    background-size: cover !important;
}

.slide-bg-img-3 {
    background: linear-gradient(rgba(0, 0, 0, .6), rgba(0, 0, 0, .6)), url('@img/home/slider/3.webp') no-repeat center;
    background-size: cover !important;
}

.aerodromnaya-bg {
    background: url('@img/home/aerodromnity-plity.webp') no-repeat center;
    background-size: cover;
}

.ukladka-bg {
    background: url('@img/home/plita.webp') no-repeat top;
    background-size: cover;
}
</style>
